import React from 'react';
import styled from 'styled-components';

const HeroSection = styled.section`
  position: relative;
  width: 100%;
  height: 838px;
  background: url('/images/Hero.png') no-repeat center center;
  background-size: cover;
  overflow: hidden;

  @media (max-width: 768px) {
    height: 700px;
    background-position: center top;
  }
`;

const HeroLogo = styled.div`
  position: absolute;
  top: 100px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;

  img {
    height: 64px;

    @media (max-width: 768px) {
      width: 169px;
      height: 99px;
    }
  }

  @media (max-width: 768px) {
    top: 80px;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const HeroContent = styled.div`
  position: absolute;
  top: 42%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 580px;
  text-align: center;
  z-index: 20;
  color: #000;
  padding: 0 20px;

  @media (max-width: 768px) {
    display: none;
  }
`;

const Title = styled.h1`
  font-size: 28px;
  font-weight: 800;
  text-transform: uppercase;
  margin-bottom: 14px;
  letter-spacing: 6.2px;
  line-height: 70px;
`;

const Description = styled.p`
  font-size: 15px;
  line-height: 1.5;
  margin-bottom: 20px;
`;

const PrimaryButton = styled.button`
  padding: 12px 24px;
  background: #27AE60;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  margin-bottom: 10px;

  &:hover {
    background: #219653;
  }
`;

const LinkText = styled.a`
  font-size: 15px;
  color: #27AE60;
  text-decoration: underline;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    color: #219653;
  }
`;

function Hero() {
  return (
    <HeroSection>
      <HeroLogo>
        <img
          src="/images/logo-principal.png"
          alt="Nação Saúde"
          style={{ width: '261px', height: '153px' }}
        />
      </HeroLogo>

      <HeroContent>
        <Title>TODA VIDA IMPORTA!</Title>
        <Description>
          Acesso a consultas, exames, telemedicina Einstein (24h), descontos em medicamentos, bem-estar e muito mais. Tudo por um valor que cabe no seu bolso.
        </Description>
        <PrimaryButton
          onClick={() => {
            const planosSection = document.getElementById('planos');
            if (planosSection) {
              planosSection.scrollIntoView({ behavior: 'smooth' });
            }
          }}
        >
          Contratar agora
        </PrimaryButton>
        <div>
          <LinkText href="#planos">Quero conhecer os planos</LinkText>
        </div>
      </HeroContent>
    </HeroSection>
  );
}

export default Hero;
